// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DateField__wrapper__CZDOx","field":"DateField__field__MNwib","segment":"DateField__segment__jt18W","placeholder":"DateField__placeholder__30GWb"};